// router setup
import routes from './routes/routes'
import Axios from 'axios'

const GlobalMixin = {
  methods: {
    imgUrl: function (id) {
      return process.env.API_URL + 'file/' + id
    },
    ajax: function (url, method, params, successFn, errorFn) {
      var me = this
      var onSuccess = typeof successFn === 'undefined' ? function (data) {} : successFn
      var onError = typeof errorFn === 'undefined' ? me.ajaxErrorFn : errorFn
      var config = {
        url: url,
        method: typeof method === 'undefined' ? 'GET' : method,
        withCredentials: true
      }
      if (!params) {
        params = {}
      }
      if (config.method === 'GET') {
        config.params = params
      } else {
        config.data = params
      }
      Axios(config)
        .then(response => {
          if (me.respSuccess(response)) {
            onSuccess(me.respData(response))
          } else {
            onError(me.respMessage(response))
          }
        })
        .catch(e => {
          onError(me.errorMessage(e.message))
        })
    },
    ajaxErrorFn: function (message) {
      this.errorMessage('Errore', message)
    },
    /* Funzioni per l'autenticazione */
    login: function (username, password, stayConnected, addCallBack) {
      var me = this
      var url = process.env.API_URL + 'auth/login'
      var method = 'POST'
      var params = {
        username: username,
        password: password,
        stayConnected: stayConnected
      }
      var successFn = function (data) {
        me.$root.$data.user = data.user
        me.$root.$router.push('/')
        me.successMessage('Benvenuto ' + me.$root.$data.user.username)
        if (typeof addCallBack === 'function') {
          addCallBack(true)
        }
      }
      var errorFn = function (message) {
        me.$root.$data.user = null
        me.errorMessage('Errore', message)
        if (typeof addCallBack === 'function') {
          addCallBack(false)
        }
      }
      me.ajax(url, method, params, successFn, errorFn)
    },
    logout: function () {
      var me = this
      var url = process.env.API_URL + 'auth/logout'
      var method = 'GET'
      var params = {}
      var successFn = function (data) {
        me.$root.$data.user = null
        me.successMessage('Log out avvenuto correttamente')
        me.$root.$router.push('/login')
      }
      var errorFn = function (message) {
        me.$root.$data.user = null
        me.successMessage('Log out avvenuto correttamente')
        me.$root.$router.push('/login')
      }
      me.ajax(url, method, params, successFn, errorFn)
    },
    checkLogin: function () {
      var me = this
      var url = process.env.API_URL + 'auth/check'
      var method = 'GET'
      var params = {}
      var successFn = function (data) {
        me.$root.$data.user = data.user
        me.successMessage('Benvenuto ' + me.$root.$data.user.username)
        me.$root.$router.addRoutes(routes)
      }
      var errorFn = function (message) {
        me.$root.$data.user = null
        me.$root.$router.addRoutes(routes)
      }
      me.ajax(url, method, params, successFn, errorFn)
    },
    checkAuthType: function (arrayType) {
      var me = this
      var loggedUserType = me.$root.$data.user.type
      if (typeof arrayType !== 'undefined') {
        if (typeof arrayType === 'string') {
          arrayType = [arrayType]
        }
        if (!arrayType.some(record => record === loggedUserType)) {
          return false
        }
      }
      return true
    },
    /* Funzioni di elaborazione risposta dal server */
    respSuccess: function (response) {
      if (response && response.data && response.data.result === 'success') {
        return true
      } else {
        return false
      }
    },
    respData: function (response) {
      if (response && response.data) {
        return response.data.data
      }
    },
    respMessage: function (response) {
      if (response && response.data) {
        return response.data.message
      }
    },
    /* funzioni per visualizzare le notifiche */
    errorMessage: function (title, message) {
      this.$notify({
        type: 'danger',
        icon: 'fa fa-exclamation-circle',
        title: title || '',
        message: message || '',
        horizontalAlign: 'center',
        verticalAlign: 'bottom'
      })
    },
    successMessage: function (title, message) {
      this.$notify({
        type: 'success',
        icon: 'fa fa-check-circle',
        title: title || '',
        message: message || '',
        horizontalAlign: 'center',
        verticalAlign: 'bottom'
      })
    },
    dateToString: function (date) {
      var tzoffset = date.getTimezoneOffset() * 60000
      return (new Date(date.getTime() - tzoffset)).toISOString().substr(0, 19).replace('T', ' ')
    },
    todayToString: function () {
      return this.dateToString(new Date()).substr(0, 10)
    },
    toUpperFirst: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    formatDate: function (date) {
      if (typeof date === 'object' && date instanceof Date) {
        date = this.dateToString(date)
      }
      if (typeof date === 'string') {
        if (date.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}/)) {
          return date.substr(8, 2) + '/' + date.substr(5, 2) + '/' + date.substr(0, 4)
        }
      }
      return ''
    },
    numberToString: function (number, decimals) {
      if (typeof number !== 'number') {
        return ''
      }
      if (typeof decimals === 'undefined') {
        decimals = 2
      }
      return number.toFixed(decimals).replace('.', ',').replace(/\d(?=(\d{3})+,)/g, '$&.')
    },
    showModal: function (template, props, modalParameters, eventListeners) {
      if (typeof props === 'undefined') {
        props = {}
      }
      if (typeof modalParameters === 'undefined') {
        modalParameters = {}
      }
      if (typeof eventListeners === 'undefined') {
        eventListeners = {}
      }
      modalParameters.height = '85%'
      modalParameters.width = '85%'
      this.$modal.show(
        {
          template: template,
          props: Object.keys(props)
        },
        props,
        modalParameters,
        eventListeners
      )
    }
  }
}

export default GlobalMixin



// WEBPACK FOOTER //
// ./src/GlobalMixin.js